// source: achievement-manager.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.achievementmanager.BestDay', null, global);
goog.exportSymbol('proto.achievementmanager.Certificate', null, global);
goog.exportSymbol('proto.achievementmanager.CertificateAccount', null, global);
goog.exportSymbol('proto.achievementmanager.CertificateStatus', null, global);
goog.exportSymbol('proto.achievementmanager.DeleteCertificateReply', null, global);
goog.exportSymbol('proto.achievementmanager.DeleteCertificateReq', null, global);
goog.exportSymbol('proto.achievementmanager.Footer', null, global);
goog.exportSymbol('proto.achievementmanager.GenerateCertificateReply', null, global);
goog.exportSymbol('proto.achievementmanager.GenerateCertificateReq', null, global);
goog.exportSymbol('proto.achievementmanager.GetCertificateReply', null, global);
goog.exportSymbol('proto.achievementmanager.GetCertificateReq', null, global);
goog.exportSymbol('proto.achievementmanager.GetSharedCertificateReply', null, global);
goog.exportSymbol('proto.achievementmanager.GetSharedCertificateReq', null, global);
goog.exportSymbol('proto.achievementmanager.IntDeleteUserCertificatesReply', null, global);
goog.exportSymbol('proto.achievementmanager.IntDeleteUserCertificatesReq', null, global);
goog.exportSymbol('proto.achievementmanager.IntGetCertificateReply', null, global);
goog.exportSymbol('proto.achievementmanager.IntGetCertificateReq', null, global);
goog.exportSymbol('proto.achievementmanager.IntRevokeCertificatesReply', null, global);
goog.exportSymbol('proto.achievementmanager.IntRevokeCertificatesReq', null, global);
goog.exportSymbol('proto.achievementmanager.ListMyCertificatesReply', null, global);
goog.exportSymbol('proto.achievementmanager.ListMyCertificatesReq', null, global);
goog.exportSymbol('proto.achievementmanager.Money', null, global);
goog.exportSymbol('proto.achievementmanager.PnlPoint', null, global);
goog.exportSymbol('proto.achievementmanager.PublicCertificate', null, global);
goog.exportSymbol('proto.achievementmanager.TimeRange', null, global);
goog.exportSymbol('proto.achievementmanager.Trader', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.Money = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.achievementmanager.Money, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.Money.displayName = 'proto.achievementmanager.Money';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.CertificateAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.achievementmanager.CertificateAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.CertificateAccount.displayName = 'proto.achievementmanager.CertificateAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.PnlPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.achievementmanager.PnlPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.PnlPoint.displayName = 'proto.achievementmanager.PnlPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.Trader = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.achievementmanager.Trader, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.Trader.displayName = 'proto.achievementmanager.Trader';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.Footer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.achievementmanager.Footer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.Footer.displayName = 'proto.achievementmanager.Footer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.BestDay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.achievementmanager.BestDay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.BestDay.displayName = 'proto.achievementmanager.BestDay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.Certificate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.achievementmanager.Certificate.repeatedFields_, null);
};
goog.inherits(proto.achievementmanager.Certificate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.Certificate.displayName = 'proto.achievementmanager.Certificate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.PublicCertificate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.achievementmanager.PublicCertificate.repeatedFields_, null);
};
goog.inherits(proto.achievementmanager.PublicCertificate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.PublicCertificate.displayName = 'proto.achievementmanager.PublicCertificate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.GenerateCertificateReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.achievementmanager.GenerateCertificateReq.repeatedFields_, null);
};
goog.inherits(proto.achievementmanager.GenerateCertificateReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.GenerateCertificateReq.displayName = 'proto.achievementmanager.GenerateCertificateReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.GenerateCertificateReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.achievementmanager.GenerateCertificateReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.GenerateCertificateReply.displayName = 'proto.achievementmanager.GenerateCertificateReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.GetCertificateReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.achievementmanager.GetCertificateReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.GetCertificateReq.displayName = 'proto.achievementmanager.GetCertificateReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.GetCertificateReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.achievementmanager.GetCertificateReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.GetCertificateReply.displayName = 'proto.achievementmanager.GetCertificateReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.ListMyCertificatesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.achievementmanager.ListMyCertificatesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.ListMyCertificatesReq.displayName = 'proto.achievementmanager.ListMyCertificatesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.ListMyCertificatesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.achievementmanager.ListMyCertificatesReply.repeatedFields_, null);
};
goog.inherits(proto.achievementmanager.ListMyCertificatesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.ListMyCertificatesReply.displayName = 'proto.achievementmanager.ListMyCertificatesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.DeleteCertificateReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.achievementmanager.DeleteCertificateReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.DeleteCertificateReq.displayName = 'proto.achievementmanager.DeleteCertificateReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.DeleteCertificateReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.achievementmanager.DeleteCertificateReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.DeleteCertificateReply.displayName = 'proto.achievementmanager.DeleteCertificateReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.GetSharedCertificateReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.achievementmanager.GetSharedCertificateReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.GetSharedCertificateReq.displayName = 'proto.achievementmanager.GetSharedCertificateReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.GetSharedCertificateReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.achievementmanager.GetSharedCertificateReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.GetSharedCertificateReply.displayName = 'proto.achievementmanager.GetSharedCertificateReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.IntRevokeCertificatesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.achievementmanager.IntRevokeCertificatesReq.repeatedFields_, null);
};
goog.inherits(proto.achievementmanager.IntRevokeCertificatesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.IntRevokeCertificatesReq.displayName = 'proto.achievementmanager.IntRevokeCertificatesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.IntRevokeCertificatesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.achievementmanager.IntRevokeCertificatesReply.repeatedFields_, null);
};
goog.inherits(proto.achievementmanager.IntRevokeCertificatesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.IntRevokeCertificatesReply.displayName = 'proto.achievementmanager.IntRevokeCertificatesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.IntDeleteUserCertificatesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.achievementmanager.IntDeleteUserCertificatesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.IntDeleteUserCertificatesReq.displayName = 'proto.achievementmanager.IntDeleteUserCertificatesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.IntDeleteUserCertificatesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.achievementmanager.IntDeleteUserCertificatesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.IntDeleteUserCertificatesReply.displayName = 'proto.achievementmanager.IntDeleteUserCertificatesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.IntGetCertificateReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.achievementmanager.IntGetCertificateReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.IntGetCertificateReq.displayName = 'proto.achievementmanager.IntGetCertificateReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.achievementmanager.IntGetCertificateReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.achievementmanager.IntGetCertificateReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.achievementmanager.IntGetCertificateReply.displayName = 'proto.achievementmanager.IntGetCertificateReply';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.Money.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.Money.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.Money} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.Money.toObject = function(includeInstance, msg) {
  var f, obj = {
amount: jspb.Message.getFieldWithDefault(msg, 1, ""),
currency: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.Money}
 */
proto.achievementmanager.Money.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.Money;
  return proto.achievementmanager.Money.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.Money} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.Money}
 */
proto.achievementmanager.Money.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAmount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.Money.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.Money.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.Money} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.Money.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string amount = 1;
 * @return {string}
 */
proto.achievementmanager.Money.prototype.getAmount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.Money} returns this
 */
proto.achievementmanager.Money.prototype.setAmount = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string currency = 2;
 * @return {string}
 */
proto.achievementmanager.Money.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.Money} returns this
 */
proto.achievementmanager.Money.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.CertificateAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.CertificateAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.CertificateAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.CertificateAccount.toObject = function(includeInstance, msg) {
  var f, obj = {
label: jspb.Message.getFieldWithDefault(msg, 1, ""),
nickname: jspb.Message.getFieldWithDefault(msg, 2, ""),
platform: jspb.Message.getFieldWithDefault(msg, 3, ""),
broker: jspb.Message.getFieldWithDefault(msg, 4, ""),
marketType: jspb.Message.getFieldWithDefault(msg, 5, ""),
pnl: (f = msg.getPnl()) && proto.achievementmanager.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.CertificateAccount}
 */
proto.achievementmanager.CertificateAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.CertificateAccount;
  return proto.achievementmanager.CertificateAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.CertificateAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.CertificateAccount}
 */
proto.achievementmanager.CertificateAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketType(value);
      break;
    case 6:
      var value = new proto.achievementmanager.Money;
      reader.readMessage(value,proto.achievementmanager.Money.deserializeBinaryFromReader);
      msg.setPnl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.CertificateAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.CertificateAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.CertificateAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.CertificateAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMarketType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPnl();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.achievementmanager.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional string label = 1;
 * @return {string}
 */
proto.achievementmanager.CertificateAccount.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.CertificateAccount} returns this
 */
proto.achievementmanager.CertificateAccount.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string nickname = 2;
 * @return {string}
 */
proto.achievementmanager.CertificateAccount.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.CertificateAccount} returns this
 */
proto.achievementmanager.CertificateAccount.prototype.setNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string platform = 3;
 * @return {string}
 */
proto.achievementmanager.CertificateAccount.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.CertificateAccount} returns this
 */
proto.achievementmanager.CertificateAccount.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string broker = 4;
 * @return {string}
 */
proto.achievementmanager.CertificateAccount.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.CertificateAccount} returns this
 */
proto.achievementmanager.CertificateAccount.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string market_type = 5;
 * @return {string}
 */
proto.achievementmanager.CertificateAccount.prototype.getMarketType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.CertificateAccount} returns this
 */
proto.achievementmanager.CertificateAccount.prototype.setMarketType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Money pnl = 6;
 * @return {?proto.achievementmanager.Money}
 */
proto.achievementmanager.CertificateAccount.prototype.getPnl = function() {
  return /** @type{?proto.achievementmanager.Money} */ (
    jspb.Message.getWrapperField(this, proto.achievementmanager.Money, 6));
};


/**
 * @param {?proto.achievementmanager.Money|undefined} value
 * @return {!proto.achievementmanager.CertificateAccount} returns this
*/
proto.achievementmanager.CertificateAccount.prototype.setPnl = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.achievementmanager.CertificateAccount} returns this
 */
proto.achievementmanager.CertificateAccount.prototype.clearPnl = function() {
  return this.setPnl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.achievementmanager.CertificateAccount.prototype.hasPnl = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.PnlPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.PnlPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.PnlPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.PnlPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
date: jspb.Message.getFieldWithDefault(msg, 1, ""),
pnl: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.PnlPoint}
 */
proto.achievementmanager.PnlPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.PnlPoint;
  return proto.achievementmanager.PnlPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.PnlPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.PnlPoint}
 */
proto.achievementmanager.PnlPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPnl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.PnlPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.PnlPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.PnlPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.PnlPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPnl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.achievementmanager.PnlPoint.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.PnlPoint} returns this
 */
proto.achievementmanager.PnlPoint.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string pnl = 2;
 * @return {string}
 */
proto.achievementmanager.PnlPoint.prototype.getPnl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.PnlPoint} returns this
 */
proto.achievementmanager.PnlPoint.prototype.setPnl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.Trader.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.Trader.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.Trader} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.Trader.toObject = function(includeInstance, msg) {
  var f, obj = {
displayName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.Trader}
 */
proto.achievementmanager.Trader.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.Trader;
  return proto.achievementmanager.Trader.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.Trader} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.Trader}
 */
proto.achievementmanager.Trader.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.Trader.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.Trader.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.Trader} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.Trader.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string display_name = 1;
 * @return {string}
 */
proto.achievementmanager.Trader.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.Trader} returns this
 */
proto.achievementmanager.Trader.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.Footer.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.Footer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.Footer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.Footer.toObject = function(includeInstance, msg) {
  var f, obj = {
promoCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
disclaimerVersion: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.Footer}
 */
proto.achievementmanager.Footer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.Footer;
  return proto.achievementmanager.Footer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.Footer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.Footer}
 */
proto.achievementmanager.Footer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPromoCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisclaimerVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.Footer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.Footer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.Footer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.Footer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPromoCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisclaimerVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string promo_code = 1;
 * @return {string}
 */
proto.achievementmanager.Footer.prototype.getPromoCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.Footer} returns this
 */
proto.achievementmanager.Footer.prototype.setPromoCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 disclaimer_version = 2;
 * @return {number}
 */
proto.achievementmanager.Footer.prototype.getDisclaimerVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.achievementmanager.Footer} returns this
 */
proto.achievementmanager.Footer.prototype.setDisclaimerVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.BestDay.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.BestDay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.BestDay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.BestDay.toObject = function(includeInstance, msg) {
  var f, obj = {
date: jspb.Message.getFieldWithDefault(msg, 1, ""),
pnl: (f = msg.getPnl()) && proto.achievementmanager.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.BestDay}
 */
proto.achievementmanager.BestDay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.BestDay;
  return proto.achievementmanager.BestDay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.BestDay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.BestDay}
 */
proto.achievementmanager.BestDay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = new proto.achievementmanager.Money;
      reader.readMessage(value,proto.achievementmanager.Money.deserializeBinaryFromReader);
      msg.setPnl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.BestDay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.BestDay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.BestDay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.BestDay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPnl();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.achievementmanager.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.achievementmanager.BestDay.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.BestDay} returns this
 */
proto.achievementmanager.BestDay.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Money pnl = 2;
 * @return {?proto.achievementmanager.Money}
 */
proto.achievementmanager.BestDay.prototype.getPnl = function() {
  return /** @type{?proto.achievementmanager.Money} */ (
    jspb.Message.getWrapperField(this, proto.achievementmanager.Money, 2));
};


/**
 * @param {?proto.achievementmanager.Money|undefined} value
 * @return {!proto.achievementmanager.BestDay} returns this
*/
proto.achievementmanager.BestDay.prototype.setPnl = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.achievementmanager.BestDay} returns this
 */
proto.achievementmanager.BestDay.prototype.clearPnl = function() {
  return this.setPnl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.achievementmanager.BestDay.prototype.hasPnl = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.achievementmanager.Certificate.repeatedFields_ = [17,19];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.Certificate.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.Certificate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.Certificate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.Certificate.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
code: jspb.Message.getFieldWithDefault(msg, 2, ""),
timeRange: jspb.Message.getFieldWithDefault(msg, 3, 0),
periodStart: jspb.Message.getFieldWithDefault(msg, 4, ""),
periodEnd: jspb.Message.getFieldWithDefault(msg, 5, ""),
isPartial: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
generatedAt: (f = msg.getGeneratedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
periodLabel: jspb.Message.getFieldWithDefault(msg, 8, ""),
tradingDays: jspb.Message.getFieldWithDefault(msg, 9, 0),
accountCount: jspb.Message.getFieldWithDefault(msg, 10, 0),
netProfit: (f = msg.getNetProfit()) && proto.achievementmanager.Money.toObject(includeInstance, f),
hasTradeCounts: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
winRate: jspb.Message.getFieldWithDefault(msg, 13, ""),
tradesTaken: jspb.Message.getFieldWithDefault(msg, 14, 0),
dayProfitStreak: jspb.Message.getFieldWithDefault(msg, 15, 0),
bestDay: (f = msg.getBestDay()) && proto.achievementmanager.BestDay.toObject(includeInstance, f),
accountsList: jspb.Message.toObjectList(msg.getAccountsList(),
    proto.achievementmanager.CertificateAccount.toObject, includeInstance),
seriesInterval: jspb.Message.getFieldWithDefault(msg, 18, ""),
seriesList: jspb.Message.toObjectList(msg.getSeriesList(),
    proto.achievementmanager.PnlPoint.toObject, includeInstance),
status: jspb.Message.getFieldWithDefault(msg, 20, 0),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
schemaVersion: jspb.Message.getFieldWithDefault(msg, 22, 0),
periodTitle: jspb.Message.getFieldWithDefault(msg, 23, ""),
isFinal: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
periodKey: jspb.Message.getFieldWithDefault(msg, 25, ""),
shareUrl: jspb.Message.getFieldWithDefault(msg, 26, ""),
trader: (f = msg.getTrader()) && proto.achievementmanager.Trader.toObject(includeInstance, f),
footer: (f = msg.getFooter()) && proto.achievementmanager.Footer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.Certificate}
 */
proto.achievementmanager.Certificate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.Certificate;
  return proto.achievementmanager.Certificate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.Certificate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.Certificate}
 */
proto.achievementmanager.Certificate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 3:
      var value = /** @type {!proto.achievementmanager.TimeRange} */ (reader.readEnum());
      msg.setTimeRange(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPeriodStart(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPeriodEnd(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPartial(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setGeneratedAt(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPeriodLabel(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTradingDays(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAccountCount(value);
      break;
    case 11:
      var value = new proto.achievementmanager.Money;
      reader.readMessage(value,proto.achievementmanager.Money.deserializeBinaryFromReader);
      msg.setNetProfit(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasTradeCounts(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setWinRate(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTradesTaken(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDayProfitStreak(value);
      break;
    case 16:
      var value = new proto.achievementmanager.BestDay;
      reader.readMessage(value,proto.achievementmanager.BestDay.deserializeBinaryFromReader);
      msg.setBestDay(value);
      break;
    case 17:
      var value = new proto.achievementmanager.CertificateAccount;
      reader.readMessage(value,proto.achievementmanager.CertificateAccount.deserializeBinaryFromReader);
      msg.addAccounts(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setSeriesInterval(value);
      break;
    case 19:
      var value = new proto.achievementmanager.PnlPoint;
      reader.readMessage(value,proto.achievementmanager.PnlPoint.deserializeBinaryFromReader);
      msg.addSeries(value);
      break;
    case 20:
      var value = /** @type {!proto.achievementmanager.CertificateStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 21:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSchemaVersion(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setPeriodTitle(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFinal(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setPeriodKey(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareUrl(value);
      break;
    case 27:
      var value = new proto.achievementmanager.Trader;
      reader.readMessage(value,proto.achievementmanager.Trader.deserializeBinaryFromReader);
      msg.setTrader(value);
      break;
    case 28:
      var value = new proto.achievementmanager.Footer;
      reader.readMessage(value,proto.achievementmanager.Footer.deserializeBinaryFromReader);
      msg.setFooter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.Certificate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.Certificate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.Certificate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.Certificate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTimeRange();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPeriodStart();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPeriodEnd();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIsPartial();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getGeneratedAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPeriodLabel();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTradingDays();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getAccountCount();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getNetProfit();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.achievementmanager.Money.serializeBinaryToWriter
    );
  }
  f = message.getHasTradeCounts();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getWinRate();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getTradesTaken();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getDayProfitStreak();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getBestDay();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.achievementmanager.BestDay.serializeBinaryToWriter
    );
  }
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      17,
      f,
      proto.achievementmanager.CertificateAccount.serializeBinaryToWriter
    );
  }
  f = message.getSeriesInterval();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getSeriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      19,
      f,
      proto.achievementmanager.PnlPoint.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      20,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSchemaVersion();
  if (f !== 0) {
    writer.writeInt32(
      22,
      f
    );
  }
  f = message.getPeriodTitle();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getIsFinal();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getPeriodKey();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getShareUrl();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getTrader();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      proto.achievementmanager.Trader.serializeBinaryToWriter
    );
  }
  f = message.getFooter();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      proto.achievementmanager.Footer.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.achievementmanager.Certificate.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string code = 2;
 * @return {string}
 */
proto.achievementmanager.Certificate.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional TimeRange time_range = 3;
 * @return {!proto.achievementmanager.TimeRange}
 */
proto.achievementmanager.Certificate.prototype.getTimeRange = function() {
  return /** @type {!proto.achievementmanager.TimeRange} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.achievementmanager.TimeRange} value
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.setTimeRange = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string period_start = 4;
 * @return {string}
 */
proto.achievementmanager.Certificate.prototype.getPeriodStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.setPeriodStart = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string period_end = 5;
 * @return {string}
 */
proto.achievementmanager.Certificate.prototype.getPeriodEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.setPeriodEnd = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool is_partial = 6;
 * @return {boolean}
 */
proto.achievementmanager.Certificate.prototype.getIsPartial = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.setIsPartial = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp generated_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.achievementmanager.Certificate.prototype.getGeneratedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.achievementmanager.Certificate} returns this
*/
proto.achievementmanager.Certificate.prototype.setGeneratedAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.clearGeneratedAt = function() {
  return this.setGeneratedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.achievementmanager.Certificate.prototype.hasGeneratedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string period_label = 8;
 * @return {string}
 */
proto.achievementmanager.Certificate.prototype.getPeriodLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.setPeriodLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 trading_days = 9;
 * @return {number}
 */
proto.achievementmanager.Certificate.prototype.getTradingDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.setTradingDays = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 account_count = 10;
 * @return {number}
 */
proto.achievementmanager.Certificate.prototype.getAccountCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.setAccountCount = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional Money net_profit = 11;
 * @return {?proto.achievementmanager.Money}
 */
proto.achievementmanager.Certificate.prototype.getNetProfit = function() {
  return /** @type{?proto.achievementmanager.Money} */ (
    jspb.Message.getWrapperField(this, proto.achievementmanager.Money, 11));
};


/**
 * @param {?proto.achievementmanager.Money|undefined} value
 * @return {!proto.achievementmanager.Certificate} returns this
*/
proto.achievementmanager.Certificate.prototype.setNetProfit = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.clearNetProfit = function() {
  return this.setNetProfit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.achievementmanager.Certificate.prototype.hasNetProfit = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional bool has_trade_counts = 12;
 * @return {boolean}
 */
proto.achievementmanager.Certificate.prototype.getHasTradeCounts = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.setHasTradeCounts = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional string win_rate = 13;
 * @return {string}
 */
proto.achievementmanager.Certificate.prototype.getWinRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.setWinRate = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int64 trades_taken = 14;
 * @return {number}
 */
proto.achievementmanager.Certificate.prototype.getTradesTaken = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.setTradesTaken = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 day_profit_streak = 15;
 * @return {number}
 */
proto.achievementmanager.Certificate.prototype.getDayProfitStreak = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.setDayProfitStreak = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional BestDay best_day = 16;
 * @return {?proto.achievementmanager.BestDay}
 */
proto.achievementmanager.Certificate.prototype.getBestDay = function() {
  return /** @type{?proto.achievementmanager.BestDay} */ (
    jspb.Message.getWrapperField(this, proto.achievementmanager.BestDay, 16));
};


/**
 * @param {?proto.achievementmanager.BestDay|undefined} value
 * @return {!proto.achievementmanager.Certificate} returns this
*/
proto.achievementmanager.Certificate.prototype.setBestDay = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.clearBestDay = function() {
  return this.setBestDay(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.achievementmanager.Certificate.prototype.hasBestDay = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * repeated CertificateAccount accounts = 17;
 * @return {!Array<!proto.achievementmanager.CertificateAccount>}
 */
proto.achievementmanager.Certificate.prototype.getAccountsList = function() {
  return /** @type{!Array<!proto.achievementmanager.CertificateAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.achievementmanager.CertificateAccount, 17));
};


/**
 * @param {!Array<!proto.achievementmanager.CertificateAccount>} value
 * @return {!proto.achievementmanager.Certificate} returns this
*/
proto.achievementmanager.Certificate.prototype.setAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 17, value);
};


/**
 * @param {!proto.achievementmanager.CertificateAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.achievementmanager.CertificateAccount}
 */
proto.achievementmanager.Certificate.prototype.addAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 17, opt_value, proto.achievementmanager.CertificateAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};


/**
 * optional string series_interval = 18;
 * @return {string}
 */
proto.achievementmanager.Certificate.prototype.getSeriesInterval = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.setSeriesInterval = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * repeated PnlPoint series = 19;
 * @return {!Array<!proto.achievementmanager.PnlPoint>}
 */
proto.achievementmanager.Certificate.prototype.getSeriesList = function() {
  return /** @type{!Array<!proto.achievementmanager.PnlPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.achievementmanager.PnlPoint, 19));
};


/**
 * @param {!Array<!proto.achievementmanager.PnlPoint>} value
 * @return {!proto.achievementmanager.Certificate} returns this
*/
proto.achievementmanager.Certificate.prototype.setSeriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 19, value);
};


/**
 * @param {!proto.achievementmanager.PnlPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.achievementmanager.PnlPoint}
 */
proto.achievementmanager.Certificate.prototype.addSeries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 19, opt_value, proto.achievementmanager.PnlPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.clearSeriesList = function() {
  return this.setSeriesList([]);
};


/**
 * optional CertificateStatus status = 20;
 * @return {!proto.achievementmanager.CertificateStatus}
 */
proto.achievementmanager.Certificate.prototype.getStatus = function() {
  return /** @type {!proto.achievementmanager.CertificateStatus} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {!proto.achievementmanager.CertificateStatus} value
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 20, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 21;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.achievementmanager.Certificate.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 21));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.achievementmanager.Certificate} returns this
*/
proto.achievementmanager.Certificate.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.achievementmanager.Certificate.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional int32 schema_version = 22;
 * @return {number}
 */
proto.achievementmanager.Certificate.prototype.getSchemaVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.setSchemaVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional string period_title = 23;
 * @return {string}
 */
proto.achievementmanager.Certificate.prototype.getPeriodTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.setPeriodTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional bool is_final = 24;
 * @return {boolean}
 */
proto.achievementmanager.Certificate.prototype.getIsFinal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.setIsFinal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional string period_key = 25;
 * @return {string}
 */
proto.achievementmanager.Certificate.prototype.getPeriodKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.setPeriodKey = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string share_url = 26;
 * @return {string}
 */
proto.achievementmanager.Certificate.prototype.getShareUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.setShareUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional Trader trader = 27;
 * @return {?proto.achievementmanager.Trader}
 */
proto.achievementmanager.Certificate.prototype.getTrader = function() {
  return /** @type{?proto.achievementmanager.Trader} */ (
    jspb.Message.getWrapperField(this, proto.achievementmanager.Trader, 27));
};


/**
 * @param {?proto.achievementmanager.Trader|undefined} value
 * @return {!proto.achievementmanager.Certificate} returns this
*/
proto.achievementmanager.Certificate.prototype.setTrader = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.clearTrader = function() {
  return this.setTrader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.achievementmanager.Certificate.prototype.hasTrader = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional Footer footer = 28;
 * @return {?proto.achievementmanager.Footer}
 */
proto.achievementmanager.Certificate.prototype.getFooter = function() {
  return /** @type{?proto.achievementmanager.Footer} */ (
    jspb.Message.getWrapperField(this, proto.achievementmanager.Footer, 28));
};


/**
 * @param {?proto.achievementmanager.Footer|undefined} value
 * @return {!proto.achievementmanager.Certificate} returns this
*/
proto.achievementmanager.Certificate.prototype.setFooter = function(value) {
  return jspb.Message.setWrapperField(this, 28, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.achievementmanager.Certificate} returns this
 */
proto.achievementmanager.Certificate.prototype.clearFooter = function() {
  return this.setFooter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.achievementmanager.Certificate.prototype.hasFooter = function() {
  return jspb.Message.getField(this, 28) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.achievementmanager.PublicCertificate.repeatedFields_ = [18,20];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.PublicCertificate.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.PublicCertificate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.PublicCertificate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.PublicCertificate.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
code: jspb.Message.getFieldWithDefault(msg, 2, ""),
periodTitle: jspb.Message.getFieldWithDefault(msg, 3, ""),
periodStart: jspb.Message.getFieldWithDefault(msg, 4, ""),
periodEnd: jspb.Message.getFieldWithDefault(msg, 5, ""),
isPartial: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
isFinal: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
generatedAt: (f = msg.getGeneratedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
periodLabel: jspb.Message.getFieldWithDefault(msg, 9, ""),
tradingDays: jspb.Message.getFieldWithDefault(msg, 10, 0),
accountCount: jspb.Message.getFieldWithDefault(msg, 11, 0),
netProfit: (f = msg.getNetProfit()) && proto.achievementmanager.Money.toObject(includeInstance, f),
hasTradeCounts: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
winRate: jspb.Message.getFieldWithDefault(msg, 14, ""),
tradesTaken: jspb.Message.getFieldWithDefault(msg, 15, 0),
dayProfitStreak: jspb.Message.getFieldWithDefault(msg, 16, 0),
bestDay: (f = msg.getBestDay()) && proto.achievementmanager.BestDay.toObject(includeInstance, f),
accountsList: jspb.Message.toObjectList(msg.getAccountsList(),
    proto.achievementmanager.CertificateAccount.toObject, includeInstance),
seriesInterval: jspb.Message.getFieldWithDefault(msg, 19, ""),
seriesList: jspb.Message.toObjectList(msg.getSeriesList(),
    proto.achievementmanager.PnlPoint.toObject, includeInstance),
trader: (f = msg.getTrader()) && proto.achievementmanager.Trader.toObject(includeInstance, f),
footer: (f = msg.getFooter()) && proto.achievementmanager.Footer.toObject(includeInstance, f),
shareUrl: jspb.Message.getFieldWithDefault(msg, 23, ""),
schemaVersion: jspb.Message.getFieldWithDefault(msg, 24, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.PublicCertificate}
 */
proto.achievementmanager.PublicCertificate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.PublicCertificate;
  return proto.achievementmanager.PublicCertificate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.PublicCertificate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.PublicCertificate}
 */
proto.achievementmanager.PublicCertificate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPeriodTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPeriodStart(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPeriodEnd(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPartial(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFinal(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setGeneratedAt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPeriodLabel(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTradingDays(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAccountCount(value);
      break;
    case 12:
      var value = new proto.achievementmanager.Money;
      reader.readMessage(value,proto.achievementmanager.Money.deserializeBinaryFromReader);
      msg.setNetProfit(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasTradeCounts(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setWinRate(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTradesTaken(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDayProfitStreak(value);
      break;
    case 17:
      var value = new proto.achievementmanager.BestDay;
      reader.readMessage(value,proto.achievementmanager.BestDay.deserializeBinaryFromReader);
      msg.setBestDay(value);
      break;
    case 18:
      var value = new proto.achievementmanager.CertificateAccount;
      reader.readMessage(value,proto.achievementmanager.CertificateAccount.deserializeBinaryFromReader);
      msg.addAccounts(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setSeriesInterval(value);
      break;
    case 20:
      var value = new proto.achievementmanager.PnlPoint;
      reader.readMessage(value,proto.achievementmanager.PnlPoint.deserializeBinaryFromReader);
      msg.addSeries(value);
      break;
    case 21:
      var value = new proto.achievementmanager.Trader;
      reader.readMessage(value,proto.achievementmanager.Trader.deserializeBinaryFromReader);
      msg.setTrader(value);
      break;
    case 22:
      var value = new proto.achievementmanager.Footer;
      reader.readMessage(value,proto.achievementmanager.Footer.deserializeBinaryFromReader);
      msg.setFooter(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareUrl(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSchemaVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.PublicCertificate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.PublicCertificate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.PublicCertificate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.PublicCertificate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPeriodTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPeriodStart();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPeriodEnd();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIsPartial();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getIsFinal();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getGeneratedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPeriodLabel();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getTradingDays();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getAccountCount();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getNetProfit();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.achievementmanager.Money.serializeBinaryToWriter
    );
  }
  f = message.getHasTradeCounts();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getWinRate();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getTradesTaken();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getDayProfitStreak();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getBestDay();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.achievementmanager.BestDay.serializeBinaryToWriter
    );
  }
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      proto.achievementmanager.CertificateAccount.serializeBinaryToWriter
    );
  }
  f = message.getSeriesInterval();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getSeriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      20,
      f,
      proto.achievementmanager.PnlPoint.serializeBinaryToWriter
    );
  }
  f = message.getTrader();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.achievementmanager.Trader.serializeBinaryToWriter
    );
  }
  f = message.getFooter();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.achievementmanager.Footer.serializeBinaryToWriter
    );
  }
  f = message.getShareUrl();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getSchemaVersion();
  if (f !== 0) {
    writer.writeInt32(
      24,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.achievementmanager.PublicCertificate.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string code = 2;
 * @return {string}
 */
proto.achievementmanager.PublicCertificate.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string period_title = 3;
 * @return {string}
 */
proto.achievementmanager.PublicCertificate.prototype.getPeriodTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.setPeriodTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string period_start = 4;
 * @return {string}
 */
proto.achievementmanager.PublicCertificate.prototype.getPeriodStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.setPeriodStart = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string period_end = 5;
 * @return {string}
 */
proto.achievementmanager.PublicCertificate.prototype.getPeriodEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.setPeriodEnd = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool is_partial = 6;
 * @return {boolean}
 */
proto.achievementmanager.PublicCertificate.prototype.getIsPartial = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.setIsPartial = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool is_final = 7;
 * @return {boolean}
 */
proto.achievementmanager.PublicCertificate.prototype.getIsFinal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.setIsFinal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp generated_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.achievementmanager.PublicCertificate.prototype.getGeneratedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
*/
proto.achievementmanager.PublicCertificate.prototype.setGeneratedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.clearGeneratedAt = function() {
  return this.setGeneratedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.achievementmanager.PublicCertificate.prototype.hasGeneratedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string period_label = 9;
 * @return {string}
 */
proto.achievementmanager.PublicCertificate.prototype.getPeriodLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.setPeriodLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int32 trading_days = 10;
 * @return {number}
 */
proto.achievementmanager.PublicCertificate.prototype.getTradingDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.setTradingDays = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 account_count = 11;
 * @return {number}
 */
proto.achievementmanager.PublicCertificate.prototype.getAccountCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.setAccountCount = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional Money net_profit = 12;
 * @return {?proto.achievementmanager.Money}
 */
proto.achievementmanager.PublicCertificate.prototype.getNetProfit = function() {
  return /** @type{?proto.achievementmanager.Money} */ (
    jspb.Message.getWrapperField(this, proto.achievementmanager.Money, 12));
};


/**
 * @param {?proto.achievementmanager.Money|undefined} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
*/
proto.achievementmanager.PublicCertificate.prototype.setNetProfit = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.clearNetProfit = function() {
  return this.setNetProfit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.achievementmanager.PublicCertificate.prototype.hasNetProfit = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional bool has_trade_counts = 13;
 * @return {boolean}
 */
proto.achievementmanager.PublicCertificate.prototype.getHasTradeCounts = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.setHasTradeCounts = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional string win_rate = 14;
 * @return {string}
 */
proto.achievementmanager.PublicCertificate.prototype.getWinRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.setWinRate = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional int64 trades_taken = 15;
 * @return {number}
 */
proto.achievementmanager.PublicCertificate.prototype.getTradesTaken = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.setTradesTaken = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int32 day_profit_streak = 16;
 * @return {number}
 */
proto.achievementmanager.PublicCertificate.prototype.getDayProfitStreak = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.setDayProfitStreak = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional BestDay best_day = 17;
 * @return {?proto.achievementmanager.BestDay}
 */
proto.achievementmanager.PublicCertificate.prototype.getBestDay = function() {
  return /** @type{?proto.achievementmanager.BestDay} */ (
    jspb.Message.getWrapperField(this, proto.achievementmanager.BestDay, 17));
};


/**
 * @param {?proto.achievementmanager.BestDay|undefined} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
*/
proto.achievementmanager.PublicCertificate.prototype.setBestDay = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.clearBestDay = function() {
  return this.setBestDay(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.achievementmanager.PublicCertificate.prototype.hasBestDay = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * repeated CertificateAccount accounts = 18;
 * @return {!Array<!proto.achievementmanager.CertificateAccount>}
 */
proto.achievementmanager.PublicCertificate.prototype.getAccountsList = function() {
  return /** @type{!Array<!proto.achievementmanager.CertificateAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.achievementmanager.CertificateAccount, 18));
};


/**
 * @param {!Array<!proto.achievementmanager.CertificateAccount>} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
*/
proto.achievementmanager.PublicCertificate.prototype.setAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.achievementmanager.CertificateAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.achievementmanager.CertificateAccount}
 */
proto.achievementmanager.PublicCertificate.prototype.addAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.achievementmanager.CertificateAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};


/**
 * optional string series_interval = 19;
 * @return {string}
 */
proto.achievementmanager.PublicCertificate.prototype.getSeriesInterval = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.setSeriesInterval = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * repeated PnlPoint series = 20;
 * @return {!Array<!proto.achievementmanager.PnlPoint>}
 */
proto.achievementmanager.PublicCertificate.prototype.getSeriesList = function() {
  return /** @type{!Array<!proto.achievementmanager.PnlPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.achievementmanager.PnlPoint, 20));
};


/**
 * @param {!Array<!proto.achievementmanager.PnlPoint>} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
*/
proto.achievementmanager.PublicCertificate.prototype.setSeriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 20, value);
};


/**
 * @param {!proto.achievementmanager.PnlPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.achievementmanager.PnlPoint}
 */
proto.achievementmanager.PublicCertificate.prototype.addSeries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 20, opt_value, proto.achievementmanager.PnlPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.clearSeriesList = function() {
  return this.setSeriesList([]);
};


/**
 * optional Trader trader = 21;
 * @return {?proto.achievementmanager.Trader}
 */
proto.achievementmanager.PublicCertificate.prototype.getTrader = function() {
  return /** @type{?proto.achievementmanager.Trader} */ (
    jspb.Message.getWrapperField(this, proto.achievementmanager.Trader, 21));
};


/**
 * @param {?proto.achievementmanager.Trader|undefined} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
*/
proto.achievementmanager.PublicCertificate.prototype.setTrader = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.clearTrader = function() {
  return this.setTrader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.achievementmanager.PublicCertificate.prototype.hasTrader = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional Footer footer = 22;
 * @return {?proto.achievementmanager.Footer}
 */
proto.achievementmanager.PublicCertificate.prototype.getFooter = function() {
  return /** @type{?proto.achievementmanager.Footer} */ (
    jspb.Message.getWrapperField(this, proto.achievementmanager.Footer, 22));
};


/**
 * @param {?proto.achievementmanager.Footer|undefined} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
*/
proto.achievementmanager.PublicCertificate.prototype.setFooter = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.clearFooter = function() {
  return this.setFooter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.achievementmanager.PublicCertificate.prototype.hasFooter = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional string share_url = 23;
 * @return {string}
 */
proto.achievementmanager.PublicCertificate.prototype.getShareUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.setShareUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional int32 schema_version = 24;
 * @return {number}
 */
proto.achievementmanager.PublicCertificate.prototype.getSchemaVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.achievementmanager.PublicCertificate} returns this
 */
proto.achievementmanager.PublicCertificate.prototype.setSchemaVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.achievementmanager.GenerateCertificateReq.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.GenerateCertificateReq.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.GenerateCertificateReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.GenerateCertificateReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.GenerateCertificateReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
timeRange: jspb.Message.getFieldWithDefault(msg, 2, 0),
accountIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.GenerateCertificateReq}
 */
proto.achievementmanager.GenerateCertificateReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.GenerateCertificateReq;
  return proto.achievementmanager.GenerateCertificateReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.GenerateCertificateReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.GenerateCertificateReq}
 */
proto.achievementmanager.GenerateCertificateReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {!proto.achievementmanager.TimeRange} */ (reader.readEnum());
      msg.setTimeRange(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addAccountIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.GenerateCertificateReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.GenerateCertificateReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.GenerateCertificateReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.GenerateCertificateReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTimeRange();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getAccountIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.achievementmanager.GenerateCertificateReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.GenerateCertificateReq} returns this
 */
proto.achievementmanager.GenerateCertificateReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional TimeRange time_range = 2;
 * @return {!proto.achievementmanager.TimeRange}
 */
proto.achievementmanager.GenerateCertificateReq.prototype.getTimeRange = function() {
  return /** @type {!proto.achievementmanager.TimeRange} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.achievementmanager.TimeRange} value
 * @return {!proto.achievementmanager.GenerateCertificateReq} returns this
 */
proto.achievementmanager.GenerateCertificateReq.prototype.setTimeRange = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated string account_ids = 3;
 * @return {!Array<string>}
 */
proto.achievementmanager.GenerateCertificateReq.prototype.getAccountIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.achievementmanager.GenerateCertificateReq} returns this
 */
proto.achievementmanager.GenerateCertificateReq.prototype.setAccountIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.achievementmanager.GenerateCertificateReq} returns this
 */
proto.achievementmanager.GenerateCertificateReq.prototype.addAccountIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.achievementmanager.GenerateCertificateReq} returns this
 */
proto.achievementmanager.GenerateCertificateReq.prototype.clearAccountIdsList = function() {
  return this.setAccountIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.GenerateCertificateReply.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.GenerateCertificateReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.GenerateCertificateReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.GenerateCertificateReply.toObject = function(includeInstance, msg) {
  var f, obj = {
certificate: (f = msg.getCertificate()) && proto.achievementmanager.Certificate.toObject(includeInstance, f),
reused: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.GenerateCertificateReply}
 */
proto.achievementmanager.GenerateCertificateReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.GenerateCertificateReply;
  return proto.achievementmanager.GenerateCertificateReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.GenerateCertificateReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.GenerateCertificateReply}
 */
proto.achievementmanager.GenerateCertificateReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.achievementmanager.Certificate;
      reader.readMessage(value,proto.achievementmanager.Certificate.deserializeBinaryFromReader);
      msg.setCertificate(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReused(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.GenerateCertificateReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.GenerateCertificateReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.GenerateCertificateReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.GenerateCertificateReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCertificate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.achievementmanager.Certificate.serializeBinaryToWriter
    );
  }
  f = message.getReused();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional Certificate certificate = 1;
 * @return {?proto.achievementmanager.Certificate}
 */
proto.achievementmanager.GenerateCertificateReply.prototype.getCertificate = function() {
  return /** @type{?proto.achievementmanager.Certificate} */ (
    jspb.Message.getWrapperField(this, proto.achievementmanager.Certificate, 1));
};


/**
 * @param {?proto.achievementmanager.Certificate|undefined} value
 * @return {!proto.achievementmanager.GenerateCertificateReply} returns this
*/
proto.achievementmanager.GenerateCertificateReply.prototype.setCertificate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.achievementmanager.GenerateCertificateReply} returns this
 */
proto.achievementmanager.GenerateCertificateReply.prototype.clearCertificate = function() {
  return this.setCertificate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.achievementmanager.GenerateCertificateReply.prototype.hasCertificate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool reused = 2;
 * @return {boolean}
 */
proto.achievementmanager.GenerateCertificateReply.prototype.getReused = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.achievementmanager.GenerateCertificateReply} returns this
 */
proto.achievementmanager.GenerateCertificateReply.prototype.setReused = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.GetCertificateReq.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.GetCertificateReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.GetCertificateReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.GetCertificateReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
certificateId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.GetCertificateReq}
 */
proto.achievementmanager.GetCertificateReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.GetCertificateReq;
  return proto.achievementmanager.GetCertificateReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.GetCertificateReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.GetCertificateReq}
 */
proto.achievementmanager.GetCertificateReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCertificateId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.GetCertificateReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.GetCertificateReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.GetCertificateReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.GetCertificateReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCertificateId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.achievementmanager.GetCertificateReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.GetCertificateReq} returns this
 */
proto.achievementmanager.GetCertificateReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string certificate_id = 2;
 * @return {string}
 */
proto.achievementmanager.GetCertificateReq.prototype.getCertificateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.GetCertificateReq} returns this
 */
proto.achievementmanager.GetCertificateReq.prototype.setCertificateId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.GetCertificateReply.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.GetCertificateReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.GetCertificateReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.GetCertificateReply.toObject = function(includeInstance, msg) {
  var f, obj = {
certificate: (f = msg.getCertificate()) && proto.achievementmanager.Certificate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.GetCertificateReply}
 */
proto.achievementmanager.GetCertificateReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.GetCertificateReply;
  return proto.achievementmanager.GetCertificateReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.GetCertificateReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.GetCertificateReply}
 */
proto.achievementmanager.GetCertificateReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.achievementmanager.Certificate;
      reader.readMessage(value,proto.achievementmanager.Certificate.deserializeBinaryFromReader);
      msg.setCertificate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.GetCertificateReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.GetCertificateReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.GetCertificateReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.GetCertificateReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCertificate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.achievementmanager.Certificate.serializeBinaryToWriter
    );
  }
};


/**
 * optional Certificate certificate = 1;
 * @return {?proto.achievementmanager.Certificate}
 */
proto.achievementmanager.GetCertificateReply.prototype.getCertificate = function() {
  return /** @type{?proto.achievementmanager.Certificate} */ (
    jspb.Message.getWrapperField(this, proto.achievementmanager.Certificate, 1));
};


/**
 * @param {?proto.achievementmanager.Certificate|undefined} value
 * @return {!proto.achievementmanager.GetCertificateReply} returns this
*/
proto.achievementmanager.GetCertificateReply.prototype.setCertificate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.achievementmanager.GetCertificateReply} returns this
 */
proto.achievementmanager.GetCertificateReply.prototype.clearCertificate = function() {
  return this.setCertificate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.achievementmanager.GetCertificateReply.prototype.hasCertificate = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.ListMyCertificatesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.ListMyCertificatesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.ListMyCertificatesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.ListMyCertificatesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.ListMyCertificatesReq}
 */
proto.achievementmanager.ListMyCertificatesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.ListMyCertificatesReq;
  return proto.achievementmanager.ListMyCertificatesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.ListMyCertificatesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.ListMyCertificatesReq}
 */
proto.achievementmanager.ListMyCertificatesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.ListMyCertificatesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.ListMyCertificatesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.ListMyCertificatesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.ListMyCertificatesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.achievementmanager.ListMyCertificatesReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.ListMyCertificatesReq} returns this
 */
proto.achievementmanager.ListMyCertificatesReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 page_size = 2;
 * @return {number}
 */
proto.achievementmanager.ListMyCertificatesReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.achievementmanager.ListMyCertificatesReq} returns this
 */
proto.achievementmanager.ListMyCertificatesReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string pagination_cursor = 3;
 * @return {string}
 */
proto.achievementmanager.ListMyCertificatesReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.ListMyCertificatesReq} returns this
 */
proto.achievementmanager.ListMyCertificatesReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.achievementmanager.ListMyCertificatesReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.ListMyCertificatesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.ListMyCertificatesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.ListMyCertificatesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.ListMyCertificatesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
certificatesList: jspb.Message.toObjectList(msg.getCertificatesList(),
    proto.achievementmanager.Certificate.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.ListMyCertificatesReply}
 */
proto.achievementmanager.ListMyCertificatesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.ListMyCertificatesReply;
  return proto.achievementmanager.ListMyCertificatesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.ListMyCertificatesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.ListMyCertificatesReply}
 */
proto.achievementmanager.ListMyCertificatesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.achievementmanager.Certificate;
      reader.readMessage(value,proto.achievementmanager.Certificate.deserializeBinaryFromReader);
      msg.addCertificates(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.ListMyCertificatesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.ListMyCertificatesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.ListMyCertificatesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.ListMyCertificatesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCertificatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.achievementmanager.Certificate.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated Certificate certificates = 1;
 * @return {!Array<!proto.achievementmanager.Certificate>}
 */
proto.achievementmanager.ListMyCertificatesReply.prototype.getCertificatesList = function() {
  return /** @type{!Array<!proto.achievementmanager.Certificate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.achievementmanager.Certificate, 1));
};


/**
 * @param {!Array<!proto.achievementmanager.Certificate>} value
 * @return {!proto.achievementmanager.ListMyCertificatesReply} returns this
*/
proto.achievementmanager.ListMyCertificatesReply.prototype.setCertificatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.achievementmanager.Certificate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.achievementmanager.Certificate}
 */
proto.achievementmanager.ListMyCertificatesReply.prototype.addCertificates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.achievementmanager.Certificate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.achievementmanager.ListMyCertificatesReply} returns this
 */
proto.achievementmanager.ListMyCertificatesReply.prototype.clearCertificatesList = function() {
  return this.setCertificatesList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.achievementmanager.ListMyCertificatesReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.ListMyCertificatesReply} returns this
 */
proto.achievementmanager.ListMyCertificatesReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.DeleteCertificateReq.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.DeleteCertificateReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.DeleteCertificateReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.DeleteCertificateReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
certificateId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.DeleteCertificateReq}
 */
proto.achievementmanager.DeleteCertificateReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.DeleteCertificateReq;
  return proto.achievementmanager.DeleteCertificateReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.DeleteCertificateReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.DeleteCertificateReq}
 */
proto.achievementmanager.DeleteCertificateReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCertificateId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.DeleteCertificateReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.DeleteCertificateReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.DeleteCertificateReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.DeleteCertificateReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCertificateId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.achievementmanager.DeleteCertificateReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.DeleteCertificateReq} returns this
 */
proto.achievementmanager.DeleteCertificateReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string certificate_id = 2;
 * @return {string}
 */
proto.achievementmanager.DeleteCertificateReq.prototype.getCertificateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.DeleteCertificateReq} returns this
 */
proto.achievementmanager.DeleteCertificateReq.prototype.setCertificateId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.DeleteCertificateReply.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.DeleteCertificateReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.DeleteCertificateReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.DeleteCertificateReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.DeleteCertificateReply}
 */
proto.achievementmanager.DeleteCertificateReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.DeleteCertificateReply;
  return proto.achievementmanager.DeleteCertificateReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.DeleteCertificateReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.DeleteCertificateReply}
 */
proto.achievementmanager.DeleteCertificateReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.DeleteCertificateReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.DeleteCertificateReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.DeleteCertificateReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.DeleteCertificateReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.GetSharedCertificateReq.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.GetSharedCertificateReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.GetSharedCertificateReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.GetSharedCertificateReq.toObject = function(includeInstance, msg) {
  var f, obj = {
certificateId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.GetSharedCertificateReq}
 */
proto.achievementmanager.GetSharedCertificateReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.GetSharedCertificateReq;
  return proto.achievementmanager.GetSharedCertificateReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.GetSharedCertificateReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.GetSharedCertificateReq}
 */
proto.achievementmanager.GetSharedCertificateReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCertificateId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.GetSharedCertificateReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.GetSharedCertificateReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.GetSharedCertificateReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.GetSharedCertificateReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCertificateId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string certificate_id = 1;
 * @return {string}
 */
proto.achievementmanager.GetSharedCertificateReq.prototype.getCertificateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.GetSharedCertificateReq} returns this
 */
proto.achievementmanager.GetSharedCertificateReq.prototype.setCertificateId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.GetSharedCertificateReply.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.GetSharedCertificateReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.GetSharedCertificateReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.GetSharedCertificateReply.toObject = function(includeInstance, msg) {
  var f, obj = {
status: jspb.Message.getFieldWithDefault(msg, 1, 0),
certificate: (f = msg.getCertificate()) && proto.achievementmanager.PublicCertificate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.GetSharedCertificateReply}
 */
proto.achievementmanager.GetSharedCertificateReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.GetSharedCertificateReply;
  return proto.achievementmanager.GetSharedCertificateReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.GetSharedCertificateReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.GetSharedCertificateReply}
 */
proto.achievementmanager.GetSharedCertificateReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.achievementmanager.CertificateStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = new proto.achievementmanager.PublicCertificate;
      reader.readMessage(value,proto.achievementmanager.PublicCertificate.deserializeBinaryFromReader);
      msg.setCertificate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.GetSharedCertificateReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.GetSharedCertificateReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.GetSharedCertificateReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.GetSharedCertificateReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getCertificate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.achievementmanager.PublicCertificate.serializeBinaryToWriter
    );
  }
};


/**
 * optional CertificateStatus status = 1;
 * @return {!proto.achievementmanager.CertificateStatus}
 */
proto.achievementmanager.GetSharedCertificateReply.prototype.getStatus = function() {
  return /** @type {!proto.achievementmanager.CertificateStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.achievementmanager.CertificateStatus} value
 * @return {!proto.achievementmanager.GetSharedCertificateReply} returns this
 */
proto.achievementmanager.GetSharedCertificateReply.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional PublicCertificate certificate = 2;
 * @return {?proto.achievementmanager.PublicCertificate}
 */
proto.achievementmanager.GetSharedCertificateReply.prototype.getCertificate = function() {
  return /** @type{?proto.achievementmanager.PublicCertificate} */ (
    jspb.Message.getWrapperField(this, proto.achievementmanager.PublicCertificate, 2));
};


/**
 * @param {?proto.achievementmanager.PublicCertificate|undefined} value
 * @return {!proto.achievementmanager.GetSharedCertificateReply} returns this
*/
proto.achievementmanager.GetSharedCertificateReply.prototype.setCertificate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.achievementmanager.GetSharedCertificateReply} returns this
 */
proto.achievementmanager.GetSharedCertificateReply.prototype.clearCertificate = function() {
  return this.setCertificate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.achievementmanager.GetSharedCertificateReply.prototype.hasCertificate = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.achievementmanager.IntRevokeCertificatesReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.IntRevokeCertificatesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.IntRevokeCertificatesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.IntRevokeCertificatesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.IntRevokeCertificatesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
certificateIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
reason: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.IntRevokeCertificatesReq}
 */
proto.achievementmanager.IntRevokeCertificatesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.IntRevokeCertificatesReq;
  return proto.achievementmanager.IntRevokeCertificatesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.IntRevokeCertificatesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.IntRevokeCertificatesReq}
 */
proto.achievementmanager.IntRevokeCertificatesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addCertificateIds(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.IntRevokeCertificatesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.IntRevokeCertificatesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.IntRevokeCertificatesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.IntRevokeCertificatesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCertificateIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated string certificate_ids = 1;
 * @return {!Array<string>}
 */
proto.achievementmanager.IntRevokeCertificatesReq.prototype.getCertificateIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.achievementmanager.IntRevokeCertificatesReq} returns this
 */
proto.achievementmanager.IntRevokeCertificatesReq.prototype.setCertificateIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.achievementmanager.IntRevokeCertificatesReq} returns this
 */
proto.achievementmanager.IntRevokeCertificatesReq.prototype.addCertificateIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.achievementmanager.IntRevokeCertificatesReq} returns this
 */
proto.achievementmanager.IntRevokeCertificatesReq.prototype.clearCertificateIdsList = function() {
  return this.setCertificateIdsList([]);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.achievementmanager.IntRevokeCertificatesReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.IntRevokeCertificatesReq} returns this
 */
proto.achievementmanager.IntRevokeCertificatesReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string reason = 3;
 * @return {string}
 */
proto.achievementmanager.IntRevokeCertificatesReq.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.IntRevokeCertificatesReq} returns this
 */
proto.achievementmanager.IntRevokeCertificatesReq.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.achievementmanager.IntRevokeCertificatesReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.IntRevokeCertificatesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.IntRevokeCertificatesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.IntRevokeCertificatesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.IntRevokeCertificatesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
revokedIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.IntRevokeCertificatesReply}
 */
proto.achievementmanager.IntRevokeCertificatesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.IntRevokeCertificatesReply;
  return proto.achievementmanager.IntRevokeCertificatesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.IntRevokeCertificatesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.IntRevokeCertificatesReply}
 */
proto.achievementmanager.IntRevokeCertificatesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addRevokedIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.IntRevokeCertificatesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.IntRevokeCertificatesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.IntRevokeCertificatesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.IntRevokeCertificatesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRevokedIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string revoked_ids = 1;
 * @return {!Array<string>}
 */
proto.achievementmanager.IntRevokeCertificatesReply.prototype.getRevokedIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.achievementmanager.IntRevokeCertificatesReply} returns this
 */
proto.achievementmanager.IntRevokeCertificatesReply.prototype.setRevokedIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.achievementmanager.IntRevokeCertificatesReply} returns this
 */
proto.achievementmanager.IntRevokeCertificatesReply.prototype.addRevokedIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.achievementmanager.IntRevokeCertificatesReply} returns this
 */
proto.achievementmanager.IntRevokeCertificatesReply.prototype.clearRevokedIdsList = function() {
  return this.setRevokedIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.IntDeleteUserCertificatesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.IntDeleteUserCertificatesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.IntDeleteUserCertificatesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.IntDeleteUserCertificatesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.IntDeleteUserCertificatesReq}
 */
proto.achievementmanager.IntDeleteUserCertificatesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.IntDeleteUserCertificatesReq;
  return proto.achievementmanager.IntDeleteUserCertificatesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.IntDeleteUserCertificatesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.IntDeleteUserCertificatesReq}
 */
proto.achievementmanager.IntDeleteUserCertificatesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.IntDeleteUserCertificatesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.IntDeleteUserCertificatesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.IntDeleteUserCertificatesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.IntDeleteUserCertificatesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.achievementmanager.IntDeleteUserCertificatesReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.IntDeleteUserCertificatesReq} returns this
 */
proto.achievementmanager.IntDeleteUserCertificatesReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.IntDeleteUserCertificatesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.IntDeleteUserCertificatesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.IntDeleteUserCertificatesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.IntDeleteUserCertificatesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
deleted: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.IntDeleteUserCertificatesReply}
 */
proto.achievementmanager.IntDeleteUserCertificatesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.IntDeleteUserCertificatesReply;
  return proto.achievementmanager.IntDeleteUserCertificatesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.IntDeleteUserCertificatesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.IntDeleteUserCertificatesReply}
 */
proto.achievementmanager.IntDeleteUserCertificatesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.IntDeleteUserCertificatesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.IntDeleteUserCertificatesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.IntDeleteUserCertificatesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.IntDeleteUserCertificatesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeleted();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 deleted = 1;
 * @return {number}
 */
proto.achievementmanager.IntDeleteUserCertificatesReply.prototype.getDeleted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.achievementmanager.IntDeleteUserCertificatesReply} returns this
 */
proto.achievementmanager.IntDeleteUserCertificatesReply.prototype.setDeleted = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.IntGetCertificateReq.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.IntGetCertificateReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.IntGetCertificateReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.IntGetCertificateReq.toObject = function(includeInstance, msg) {
  var f, obj = {
certificateId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.IntGetCertificateReq}
 */
proto.achievementmanager.IntGetCertificateReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.IntGetCertificateReq;
  return proto.achievementmanager.IntGetCertificateReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.IntGetCertificateReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.IntGetCertificateReq}
 */
proto.achievementmanager.IntGetCertificateReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCertificateId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.IntGetCertificateReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.IntGetCertificateReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.IntGetCertificateReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.IntGetCertificateReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCertificateId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string certificate_id = 1;
 * @return {string}
 */
proto.achievementmanager.IntGetCertificateReq.prototype.getCertificateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.IntGetCertificateReq} returns this
 */
proto.achievementmanager.IntGetCertificateReq.prototype.setCertificateId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.achievementmanager.IntGetCertificateReply.prototype.toObject = function(opt_includeInstance) {
  return proto.achievementmanager.IntGetCertificateReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.achievementmanager.IntGetCertificateReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.IntGetCertificateReply.toObject = function(includeInstance, msg) {
  var f, obj = {
certificate: (f = msg.getCertificate()) && proto.achievementmanager.Certificate.toObject(includeInstance, f),
userId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.achievementmanager.IntGetCertificateReply}
 */
proto.achievementmanager.IntGetCertificateReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.achievementmanager.IntGetCertificateReply;
  return proto.achievementmanager.IntGetCertificateReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.achievementmanager.IntGetCertificateReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.achievementmanager.IntGetCertificateReply}
 */
proto.achievementmanager.IntGetCertificateReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.achievementmanager.Certificate;
      reader.readMessage(value,proto.achievementmanager.Certificate.deserializeBinaryFromReader);
      msg.setCertificate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.achievementmanager.IntGetCertificateReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.achievementmanager.IntGetCertificateReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.achievementmanager.IntGetCertificateReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.achievementmanager.IntGetCertificateReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCertificate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.achievementmanager.Certificate.serializeBinaryToWriter
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Certificate certificate = 1;
 * @return {?proto.achievementmanager.Certificate}
 */
proto.achievementmanager.IntGetCertificateReply.prototype.getCertificate = function() {
  return /** @type{?proto.achievementmanager.Certificate} */ (
    jspb.Message.getWrapperField(this, proto.achievementmanager.Certificate, 1));
};


/**
 * @param {?proto.achievementmanager.Certificate|undefined} value
 * @return {!proto.achievementmanager.IntGetCertificateReply} returns this
*/
proto.achievementmanager.IntGetCertificateReply.prototype.setCertificate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.achievementmanager.IntGetCertificateReply} returns this
 */
proto.achievementmanager.IntGetCertificateReply.prototype.clearCertificate = function() {
  return this.setCertificate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.achievementmanager.IntGetCertificateReply.prototype.hasCertificate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.achievementmanager.IntGetCertificateReply.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.achievementmanager.IntGetCertificateReply} returns this
 */
proto.achievementmanager.IntGetCertificateReply.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.achievementmanager.TimeRange = {
  TIME_RANGE_UNSPECIFIED: 0,
  TIME_RANGE_TODAY: 1,
  TIME_RANGE_YESTERDAY: 2,
  TIME_RANGE_THIS_WEEK: 3,
  TIME_RANGE_LAST_WEEK: 4,
  TIME_RANGE_THIS_MONTH: 5,
  TIME_RANGE_LAST_MONTH: 6
};

/**
 * @enum {number}
 */
proto.achievementmanager.CertificateStatus = {
  CERTIFICATE_STATUS_UNSPECIFIED: 0,
  CERTIFICATE_STATUS_ACTIVE: 1,
  CERTIFICATE_STATUS_DELETED: 2,
  CERTIFICATE_STATUS_REVOKED: 3
};

goog.object.extend(exports, proto.achievementmanager);
